import { HttpErrorResponse } from '@angular/common/http';
import { Component, TemplateRef, ViewChild, inject, input, output, signal } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';

import { CamAddEventRequest } from '@camelot/calendar';
import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput, IInputsError } from '@camelot/form-model';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { CamBaseComponent, TypedTemplateDirective, fullName } from '@camelot/utils';

import { UnavailabilityType } from '../../../services/dto/unavailability-type';
import { CamUnavailabilityFormService } from '../../../services/form/unavailability.service';
import { CamUnavailabilitiesService } from '../../../services/unavailabilities.service';

@Component({
  selector: 'cam-create-unavailability-form',
  imports: [FormComponent, TypedTemplateDirective],
  templateUrl: './create-unavailability.component.html',
  styleUrl: './create-unavailability.component.scss',
})
export class CreateUnavailabilityFormComponent extends CamBaseComponent {
  data = input<CamAddEventRequest>();

  askValidation = input.required<Subject<null>>();

  loader = input(false);
  error = input<IInputsError>({ message: '', status: ENotificationCode.none });

  isFormValid = output<boolean>();

  added = output<void>();

  @ViewChild('typeTemplate', { read: TemplateRef }) typeTemplate!: TemplateRef<void>;

  private _formService = inject(CamUnavailabilityFormService);
  private _unavailabiltiesEventService = inject(CamUnavailabilitiesService);

  public readonly form = signal<CamAbstractInput[]>([]);
  public readonly fullName = fullName;

  public readonly typeTypeToken!: { item: UnavailabilityType };
  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  ngAfterViewInit() {
    this.form.set(
      this._formService.getEventForm(
        {
          type: this.typeTemplate,
        },
        this.data()
      )
    );
  }

  public validation(data: any) {
    this.requestState.asked();

    const unavailabilities = this._formService.formatEventForm(data);
    this._registerSubscription(
      combineLatest(
        unavailabilities.map(unavailability => this._unavailabiltiesEventService.createUnavailability$(unavailability))
      ).subscribe({
        complete: () => {
          this.requestState.completed();
          this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
          this.added.emit();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      })
    );
  }
}
